import { useMutation, useQueryClient } from '@tanstack/react-query'
import { identityServices } from '@/domain/identity/identityServices'

export const useCreateKemCard = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: identityServices.createKemCard,
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: ['wallet'] })
      queryClient.invalidateQueries({ queryKey: ['identity-card-state'] })
    },
  })
}
